export const IMDB_TITLE_URL = 'https://www.imdb.com/title/'

// TODO: handle this some different way
export const DEFAULT_COUNTRY_CODE = 'pl' as const
